export enum Permission {
	CanViewDiscoverPage = 'canViewDiscoverPage',
	CanViewAnalyzePage = 'canViewAnalyzePage',
	CanViewReportPage = 'canViewReportPage',
	CanViewSetupPage = 'canViewSetupPage',
	CanViewPresentPage = 'canViewPresentPage',
	CanViewAppsPage = 'canViewAppsPage',

	CreateAlert = 'createAlert',
	EditAlert = 'editAlert',
	DeleteAlert = 'deleteAlert',
	ViewAlert = 'viewAlert',

	CanAccessActivityLog = 'canAccessActivityLog',
	CanViewZoneSettings = 'canViewZoneSettings',
	CanEditZoneSettings = 'canEditZoneSettings',
	CanViewZoneColors = 'canViewZoneColors',
	CanEditZoneColors = 'canEditZoneColors',
	CanClearPasswordHistory = 'canClearPasswordHistory',
	CanImportData = 'canImportData',
	CanPurgeData = 'canPurgeData',
	CanResetPassword = 'canResetPassword',
	CanResetUserPassword = 'canResetUserPassword',
	CanTriggerDataImport = 'canTriggerDataImport',
	CanTriggerSchemaUpdate = 'canTriggerSchemaUpdate',
	CanUploadData = 'canUploadData',
	CreateChart = 'createChart',
	CreateDashboard = 'createDashboard',
	CreatePresentation = 'createPresentation',
	CreateDataframe = 'createDataframe',
	CreateDateRange = 'createDateRange',
	CreateDimension = 'createDimension',
	CreateDimensionAttribute = 'createDimensionAttribute',
	CreateDimensionSource = 'createDimensionSource',
	CreateEtlSourceDatabase = 'createEtlSourceDatabase',
	CreateFolder = 'createFolder',
	CreateGroup = 'createGroup',
	CreateKeyMeasure = 'createKeyMeasure',
	CreateKeyMeasureFact = 'createKeyMeasureFact',
	CreateKeyMeasureSource = 'createKeyMeasureSource',
	CreatePeriod = 'createPeriod',
	CreateReport = 'createReport',
	CreateRole = 'createRole',
	CreateSchedule = 'createSchedule',
	CreateSubscription = 'createSubscription',
	CreateTable = 'createTable',
	CreateTag = 'createTag',
	CreateUnitType = 'createUnitType',
	CreateUser = 'createUser',
	CreateQuestion = 'createQuestion',
	CreateQuestionCategory = 'createQuestionCategory',
	CreateSystemSchedule = 'createSystemSchedule',
	DeleteDataframe = 'deleteDataframe',
	DeleteChart = 'deleteChart',
	DeleteReport = 'deleteReport',
	DeleteDashboard = 'deleteDashboard',
	DeleteDateRange = 'deleteDateRange',
	DeleteDimension = 'deleteDimension',
	DeleteFolder = 'deleteFolder',
	DeleteDimensionAttribute = 'deleteDimensionAttribute',
	DeleteDimensionSource = 'deleteDimensionSource',
	DeleteEtlSourceDatabase = 'deleteEtlSourceDatabase',
	DeleteGroup = 'deleteGroup',
	DeleteKeyMeasure = 'deleteKeyMeasure',
	DeleteKeyMeasureFact = 'deleteKeyMeasureFact',
	DeleteKeyMeasureSource = 'deleteKeyMeasureSource',
	DeletePeriod = 'deletePeriod',
	DeletePresentation = 'deletePresentation',
	DeleteRole = 'deleteRole',
	DeleteUnitType = 'deleteUnitType',
	DeleteUser = 'deleteUser',
	DeleteQuestion = 'deleteQuestion',
	DeleteQuestionCategory = 'deleteQuestionCategory',
	DeleteSubscription = 'deleteSubscription',
	DeleteSystemSchedule = 'deleteSystemSchedule',
	DeleteTable = 'deleteTable',
	DeleteTag = 'deleteTag',
	EditChart = 'editChart',
	EditDashboard = 'editDashboard',
	EditDataframe = 'editDataframe',
	EditDateRange = 'editDateRange',
	EditDimension = 'editDimension',
	EditDimensionAttribute = 'editDimensionAttribute',
	EditDimensionSource = 'editDimensionSource',
	EditEtlSourceDatabase = 'editETLSourceDatabase',
	EditFavorite = 'editFavorite',
	EditFolder = 'editFolder',
	EditGroup = 'editGroup',
	EditGroupSecurityRule = 'editGroupSecurityRule',
	EditKeyMeasure = 'editKeyMeasure',
	EditKeyMeasureFact = 'editKeyMeasureFact',
	EditKeyMeasureSource = 'editKeyMeasureSource',
	EditPeriod = 'editPeriod',
	EditPermission = 'editPermission',
	EditPreference = 'editPreference',
	EditPreferenceCategory = 'editPreferenceCategory',
	EditPreferenceDefinition = 'editPreferenceDefinition',
	EditPresentation = 'editPresentation',
	EditQuestion = 'editQuestion',
	EditQuestionCategory = 'editQuestionCategory',
	EditRecent = 'editRecent',
	EditReport = 'editReport',
	EditReportSchedule = 'editReportSchedule',
	EditRole = 'editRole',
	EditSubscription = 'editSubscription',
	EditSystemSchedule = 'editSystemSchedule',
	EditTable = 'editTable',
	EditTag = 'editTag',
	EditUnitType = 'editUnitType',
	EditUser = 'editUser',
	EditZoneNotification = 'editZoneNotification',
	EditZoneSettings = 'editZoneSettings',
	EditSharedEntity = 'editSharedEntity',
	ViewActiveSessions = 'viewActiveSessions',
	ViewChart = 'viewChart',
	ViewDashboard = 'viewDashboard',
	ViewDataframe = 'viewDataframe',
	ViewDateRange = 'viewDateRange',
	ViewDimension = 'viewDimension',
	ViewDimensionAttribute = 'viewDimensionAttribute',
	ViewDimensionSource = 'viewDimensionSource',
	ViewEtlSourceDatabase = 'viewETLSourceDatabase',
	ViewFavorite = 'viewFavorite',
	ViewFolder = 'viewFolder',
	ViewGroup = 'viewGroup',
	ViewGroupSecurityRule = 'viewGroupSecurityRule',
	ViewKeyMeasure = 'viewKeyMeasure',
	ViewKeyMeasureFact = 'viewKeyMeasureFact',
	ViewKeyMeasureSource = 'viewKeyMeasureSource',
	ViewLoginActivity = 'viewLoginActivity',
	ViewPeriod = 'viewPeriod',
	ViewPermission = 'viewPermission',
	ViewPreference = 'viewPreference',
	ViewPreferenceCategory = 'viewPreferenceCategory',
	ViewPreferenceDefinition = 'viewPreferenceDefinition',
	ViewPresentation = 'viewPresentation',
	ViewQuestion = 'viewQuestion',
	ViewQuestionCategory = 'viewQuestionCategory',
	ViewRecent = 'viewRecent',
	ViewReport = 'viewReport',
	ViewReportSchedule = 'viewReportSchedule',
	ViewRole = 'viewRole',
	ViewTable = 'viewTable',
	ViewTag = 'viewTag',
	ViewUnitType = 'viewUnitType',
	ViewUser = 'viewUser',
	ViewZoneNotification = 'viewZoneNotification',
	viewSharedEntity = 'viewSharedEntity',
	ViewSamlMetadata = 'viewSamlMetadata',
	CanUseAIChat = 'canUseAIChat',
	CanUseAISummaries = 'canUseAISummaries',
	CanUseAIAnalyst = 'canUseAIAnalyst',
	NA = 'N/A',
}
